export default function TenantViewLifecycleNotice({ message, onDismiss }) {
    if (!message) return null;
    return (
        <div
            role="status"
            className="mx-[var(--main-inset)] mb-[8px] flex items-start justify-between gap-[12px] border border-[color:var(--line)] bg-[color:var(--control-bg)] px-[10px] py-[8px] text-[11px] leading-[1.4] text-[color:var(--muted)]"
        >
            <span>{message}</span>
            <button
                type="button"
                onClick={onDismiss}
                aria-label="Dismiss lifecycle notice"
                className="shrink-0 bg-transparent text-[color:var(--muted-soft)] hover:text-[color:var(--ink)]"
            >
                ×
            </button>
        </div>
    );
}
